export default "__VITE_ASSET__BoQZh6Xs__"